module.exports = __webpack_public_path__ + "media/Button_09.ffec4aee.wav";